import { render, staticRenderFns } from "./AsidePitchGroup.vue?vue&type=template&id=3d28e3d6"
import script from "./AsidePitchGroup.vue?vue&type=script&lang=js"
export * from "./AsidePitchGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports